import React, { useState } from 'react';
import { useCookieConsent } from './CookieContext';
import './CookieBanner.css';

const CookieBanner = () => {
  const {
    showBanner,
    acceptAll,
    acceptEssential,
    saveCustomPreferences,
    cookiePreferences
  } = useCookieConsent();

  const [showDetails, setShowDetails] = useState(false);
  const [customPreferences, setCustomPreferences] = useState({
    analytics: cookiePreferences.analytics,
    marketing: cookiePreferences.marketing,
    functionality: cookiePreferences.functionality,
    personalization: cookiePreferences.personalization
  });

  if (!showBanner) return null;

  const handleCustomSave = () => {
    saveCustomPreferences(customPreferences);
  };

  const handlePreferenceChange = (type) => {
    setCustomPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-header">
          <h3>Gestione Cookie</h3>
        </div>
        
        <div className="cookie-banner-text">
          <p>
            Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito. 
            Puoi scegliere quali tipi di cookie accettare.
          </p>
        </div>

        {!showDetails ? (
          <div className="cookie-banner-actions">
            <button 
              className="btn btn-secondary"
              onClick={() => setShowDetails(true)}
            >
              Personalizza
            </button>
            <button 
              className="btn btn-primary"
              onClick={acceptAll}
            >
              Accetta Tutti
            </button>
            <button 
              className="btn btn-outline"
              onClick={acceptEssential}
            >
              Solo Essenziali
            </button>
          </div>
        ) : (
          <div className="cookie-details">
            <div className="cookie-category">
              <div className="category-header">
                <div className="category-info">
                  <h4>Cookie Essenziali</h4>
                  <p>Necessari per il funzionamento del sito</p>
                </div>
                <div className="category-toggle">
                  <input 
                    type="checkbox" 
                    checked={true} 
                    disabled 
                    className="toggle-switch"
                  />
                </div>
              </div>
              <div className="category-description">
                Questi cookie sono necessari per il funzionamento del sito web e non possono essere disattivati.
                Includono cookie per la sicurezza, la navigazione e le funzionalità di base.
              </div>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <div className="category-info">
                  <h4>Cookie Analytics</h4>
                  <p>Ci aiutano a migliorare il sito</p>
                </div>
                <div className="category-toggle">
                  <input 
                    type="checkbox" 
                    checked={customPreferences.analytics}
                    onChange={() => handlePreferenceChange('analytics')}
                    className="toggle-switch"
                  />
                </div>
              </div>
              <div className="category-description">
                Questi cookie ci permettono di analizzare come utilizzi il nostro sito, 
                per migliorare le prestazioni e l'esperienza utente.
              </div>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <div className="category-info">
                  <h4>Cookie Marketing</h4>
                  <p>Per pubblicità personalizzate</p>
                </div>
                <div className="category-toggle">
                  <input 
                    type="checkbox" 
                    checked={customPreferences.marketing}
                    onChange={() => handlePreferenceChange('marketing')}
                    className="toggle-switch"
                  />
                </div>
              </div>
              <div className="category-description">
                Utilizzati per mostrarti contenuti e pubblicità più rilevanti, 
                basati sui tuoi interessi e sul tuo comportamento online.
              </div>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <div className="category-info">
                  <h4>Cookie Funzionalità</h4>
                  <p>Per funzionalità avanzate del sito</p>
                </div>
                <div className="category-toggle">
                  <input 
                    type="checkbox" 
                    checked={customPreferences.functionality}
                    onChange={() => handlePreferenceChange('functionality')}
                    className="toggle-switch"
                  />
                </div>
              </div>
              <div className="category-description">
                Questi cookie abilitano funzionalità avanzate come chat, 
                preferenze di visualizzazione e altre caratteristiche interattive.
              </div>
            </div>

            <div className="cookie-category">
              <div className="category-header">
                <div className="category-info">
                  <h4>Cookie Personalizzazione</h4>
                  <p>Per un'esperienza personalizzata</p>
                </div>
                <div className="category-toggle">
                  <input 
                    type="checkbox" 
                    checked={customPreferences.personalization}
                    onChange={() => handlePreferenceChange('personalization')}
                    className="toggle-switch"
                  />
                </div>
              </div>
              <div className="category-description">
                Questi cookie ricordano le tue preferenze (lingua, regione, tema) 
                e personalizzano l'esperienza in base ai tuoi interessi.
              </div>
            </div>

            <div className="cookie-details-actions">
              <button 
                className="btn btn-secondary"
                onClick={() => setShowDetails(false)}
              >
                Indietro
              </button>
              <button 
                className="btn btn-primary"
                onClick={handleCustomSave}
              >
                Salva Preferenze
              </button>
            </div>
          </div>
        )}

        <div className="cookie-banner-footer">
          <p>
            Per maggiori informazioni, consulta la nostra{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner; 